import { lazy } from 'react'
import { registerEditor } from '../editor-registry.js'

const LazySpreadsheetEditor = lazy(() =>
  import('../../ui/SpreadsheetEditor.js').then(m => ({ default: m.SpreadsheetEditor }))
)

// CSV/TSV: Univer-based spreadsheet editor (view/edit toggle). Binary office
// formats (xlsx/xls/ods/...) are handled by Collabora — Univer is intentionally
// NOT registered for them.
registerEditor({
  notifiesFileGone: true, // #823: FileStateBanner, from the room's close
  family: 'spreadsheet',
  id: 'csv-editor',
  extensions: ['csv', 'tsv'],
  name: 'Spreadsheet Editor',
  component: LazySpreadsheetEditor,
})
